export default __webpack_public_path__ + "static/media/5C844C2F-CCF5-4B5A-8740-C67F03AAB8DE.201844d6.jpg";